"use strict";

export function draw_files(data){
	data.forEach(file => {

		let file_type_link = 'comments';

		let file_type_id_arr = file.file_type_id_arr;




		for(let i = 0; i < file_type_id_arr.length; i++) {

			let file_type_id = file_type_id_arr[i];

			//1 - comments, 2 - drivers, 3 vehicles, 4- lossruns
			if(file_type_id == '1'){
				file_type_link = 'comments';
			} else if(file_type_id == '2'){
				file_type_link = 'drivers';
			} else if(file_type_id == '3'){
				file_type_link = 'vehicles';
			}else if(file_type_id == '4'){
				file_type_link = 'loss_runs';
			}

		if(file_type_id > 0) {

			$('.lead_update_popup .files_wrap_' + file_type_link).append(
				`<div class="file-wrap">								
					<td class="file_name"><a href="${file.file_path}${file.file_name}" download="${file.file_name}">${file.file_name}</a></td>
					<span class="delete" data-file_id="${file.id}">X</span>
				</div>`
			);

		}

		}

	});
}


export function draw_attachments(files) {

	$('.lead_update_popup .attachment_file_block_ul').html('');
	let attachments_qty_number = 0;
	if (typeof files === 'object' && files !== null) {
		const fileEntries = Object.values(files);

		fileEntries.forEach(entry => {
			 if(entry.file_type_id !== '5') {
				 entry.files.forEach(ent => {
					 let file_ext = ent.file_ext;
					 if (file_ext == null || String(file_ext.trim()) === '') {
						 console.error('activity has no file_ext to display');
						 file_ext = 'bin';
					 }

					 let file_name = ent.file_name;
					 if (file_name == null || String(file_name.trim()) === '') {
						 console.error('activity has no file_name to display');
						 file_name = '[unavailable file_name]';
					 }

					 let file_href;
					 {
						 let is_valid_data_for_file_href = true;
						 let directory_path = ent.directory_path;
						 if (directory_path == null || String(directory_path.trim()) === '') {
							 is_valid_data_for_file_href = false;
						 }

						 let file_name = ent.file_name;

						 if (file_name == null || String(file_name.trim()) === '') {
							 is_valid_data_for_file_href = false;
						 }

						 let email_id = ent.email_id;

						 if (email_id == null || String(email_id.trim()) === '') {
							 email_id = '';
						 }
						 if (is_valid_data_for_file_href) {
							 file_href = directory_path + '/' + email_id + '/' + file_name;
							 file_href = file_href.replace(/\/+/g, '/')
						 }
					 }
					 if (file_href == null || String(file_href.trim()) === '') {
						 console.error('activity has no file_href to display');
						 file_href = '/error_404';
					 }


					 let file_size = ent.file_size;
					 if (file_size == null || String(file_size.trim()) === '') {
						 console.error('activity has no file_size to display');
						 file_size = '[unavailable file_size]';
					 }

					 let added_formatted_date = ent.added_formatted_date;

					 if (added_formatted_date == null || String(added_formatted_date.trim()) === '') {
						 console.error('activity has no added_formatted_date to display');
						 added_formatted_date = '[unavailable added_formatted_date]';
					 }
					 $('.lead_update_popup .attachment_file_block_ul').append(
						 `<li class="document_attached" data-link="">
							<a href="${file_href}" target="_blank" data-title="${file_name}">
								<div class="document_info_wrap document_icon_${file_ext}">
									<div class="document_info">
										<span class="title_document">${file_name}</span>
										<div class="attibutes_wrap">
											<span class="document_attributes">${file_size}</span>
											<span class="document_attributes">● ${added_formatted_date}</span>
										</div>
									</div>
								</div>
							</a>
						</li>`,
					 );
				 })
			 }
			 if(entry.file_type_id === '5') {
				 let filesList = '';
				 if (Array.isArray(entry.files)) {
					 entry.files.forEach(ent => {

						 let file_name = ent.file_name;
						 if (file_name == null || String(file_name.trim()) === '') {
							 console.error('activity has no file_name to display');
							 file_name = '[unavailable file_name]';
						 }

						 let file_href;
						 {
							 let is_valid_data_for_file_href = true;
							 let directory_path = ent.directory_path;
							 if (directory_path == null || String(directory_path.trim()) === '') {
								 is_valid_data_for_file_href = false;
							 }

							 let file_name = ent.file_name;

							 if (file_name == null || String(file_name.trim()) === '') {
								 is_valid_data_for_file_href = false;
							 }

							 let email_id = ent.email_id;

							 if (email_id == null || String(email_id.trim()) === '') {
								 is_valid_data_for_file_href = false;
							 }
							 if (is_valid_data_for_file_href) {
								 file_href = directory_path + '/' + email_id + '/' + file_name;
							 }
						 }
						 if (file_href == null || String(file_href.trim()) === '') {
							 console.error('activity has no file_href to display');
							 file_href = '/error_404';
						 }

						 let added_formatted_date = ent.added_formatted_date;

						 if (added_formatted_date == null || String(added_formatted_date.trim()) === '') {
							 console.error('activity has no added_formatted_date to display');
							 added_formatted_date = '[unavailable added_formatted_date]';
						 }
						 filesList += `
						<a href="${file_href}" target="_blank" data-title="${file_name}">
							<span class="document_attributes">${file_name}</span>
						</a> | `;
					 });
					 filesList = filesList.slice(0, -3);  // Remove last '|'

				 }


				 $('.lead_update_popup .attachment_file_block_ul').append(
					 `<li class="document_attached email" data-link="" >
						<div data-name-from="${entry.name_from}">
							<div class="document_info_wrap document_icon">
								<div class="document_info">
									<span class="title_document">${entry.name_from}</span>
									<div class="document_attributes">
											<div class="attached_emai_subject">${entry.email_subject}</div>
											<div class="attached_emai_data">${entry.added_formatted_date}</div>
									</div>
									<div class="attibutes_wrap">
										${filesList} 
									</div>
								</div>
							</div>
						</div>
					</li>`

				 );

			 }
		 });
	 }
	attachments_qty_number = $('.attachment_file_block_ul li').length;

	$('.attachments_qty_number').html(attachments_qty_number);


}


$(document).ready(function() {

	$(document).on('click', '.file-wrap .delete', function() {
		let file_id = $(this).data('file_id');

		if (confirm('Are you sure you want to delete this file?')) {
			$.ajax({
				url: '/leads/delete_file',
				type: 'POST',
				data: { file_id: file_id },
				dataType: "json",
				// processData: false,
				// contentType: false,
				success: function(response) {
					if (response.status === 'success') {
						$(`.file-wrap:has(span[data-file_id="${file_id}"])`).remove();
					}
				},
				error: function(jqXHR, textStatus, errorThrown) {
					console.log(jqXHR, textStatus, errorThrown)
				}
			});
		}
	});


	$('.file_btn').click(function(e) {
		e.preventDefault();
		let type = $(this).attr('data-type');
		$('#fileInput_' + type).click();
	});


	function preventDefaults(e) {
		e.preventDefault();
		e.stopPropagation();
	}


	let dropAreas = ['#vehicles', '#loss_runs', '#drivers', '#attachments', '#comments'];

	dropAreas.forEach(selector => {
		let dropArea = $(selector);


		if (dropArea.length === 0) {
			console.warn(`Drop area not found: ${selector}`);
			return;
		}


		// Prevent default drag behaviors
		['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
			dropArea.on(eventName, preventDefaults);
		});

		// Highlight the drop area when file is dragged over it
		dropArea.on('dragenter dragover', () => {
			dropArea.addClass('hover');
		});

		dropArea.on('dragleave drop', () => {
			dropArea.removeClass('hover');
		});

		// Handle dropped files
		dropArea.on('drop', function(e) {
			console.log(`Files dropped on: ${selector}`);
			let dt = e.originalEvent.dataTransfer;
			let files = dt.files;
			let leadID = $('.lead_update_popup').attr('data-current-lead-id');

			if (!leadID) {
				console.error('Lead ID not found');
				return;
			}

			let type = selector.substring(1);
			console.log(`Handling files for type: ${type}, leadID: ${leadID}`);
			handleFiles(files, type, leadID);
		});
	});



	$('.lead_detailed_wrap .fileInput').on('change', function () {
		let files = this.files;
		let leadID = $('.lead_update_popup').attr('data-current-lead-id');

		if (!leadID) {
			console.error('Lead ID not found for file input');
			return;
		}

		let type = $(this).attr('data-type');
		console.log(`Handling file input for type: ${type}, leadID: ${leadID}`);
		handleFiles(files, type, leadID);
	});

	function handleFiles(files, type, leadID) {
		if (!files.length) {
			console.warn('No files to handle');
			return;
		}

		[...files].forEach(file => {
			console.log(`Uploading file: ${file.name}`);
			uploadFile(file, type, leadID);
		});
		[...files].forEach(file => previewFile(file, type));
	}

	function previewFile(file, type) {
		let reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onloadend = function () {
			let img = document.createElement('img');
			img.src = reader.result;
			img.classList.add('preview-img');
			console.log(`Previewing file: ${file.name}`);
			$(`.lead_update_popup .files_wrap.files_wrap_${type}`).append(
				`<div class="file-wrap">								
					<td class="file_name"><a href="${file.file_path}${file.file_name}" download="${file.file_name}">${file.file_name}</a></td>
					<span class="delete" data-file_id="${file.id}">X</span>
				</div>`
			);
		};
	}

	function uploadFile(file, type, leadID) {
		let formData = new FormData();
		formData.append('file', file);
		formData.append('type', type);
		formData.append('lead_id', leadID);

		$.ajax({
			url: '/leads/upload_file',
			type: 'POST',
			data: formData,
			dataType: "json",
			processData: false,
			contentType: false,
			success: function(response) {
				try {
					if (response.status === 'success') {
						console.log('File uploaded successfully');
						getLeadData(leadID);
					} else {
						console.error('Upload error:', response.error);
						$(`.files_wrap_${type}`).append('<p>Error: ' + response.error + '</p>');
					}
				} catch (e) {
					console.error('JSON Parsing Error:', e);
					$(`.files_wrap_${type}`).append('<p>Parsing Error: Invalid JSON format</p>');
				}
			},
			error: function(err) {
				console.error('Upload Error:', err);
				$(`.files_wrap_${type}`).append('<p>Upload Error: ' + err.statusText + '</p>');
			}
		});
	}

});
